import param from 'jquery-param';
import { classify } from '@ember/string';

import { _getModelName, _getStore } from './build-url';

import type { ApiCollectionCommandOptions, ApiCommand } from './types';
import type ApplicationAdapter from 'volta/_pods/application/adapter';
import { isDocWithData, normalize as normalizeFn } from './serialize-and-push';
import type Model from "@ember-data/model";

export default function collectionCmd<IN = any, OUT = any, M extends typeof Model = typeof Model>(
  cmd: string,
  options: ApiCollectionCommandOptions<IN, OUT> = {}
) {
  return async function runCollectionCmd(this: M, payload: IN): Promise<OUT> {
    const _modelName = _getModelName(this);
    const _store = _getStore();
    const _adapter = _store.adapterFor(_modelName) as ApplicationAdapter;
    const { ajaxOptions, before, after } = options;
    const _cmdPayload: ApiCommand = {
      ...payload,
      _cmd: classify(cmd)
    };

    let fullUrl = _adapter._buildURL(_modelName);

    const data = (before && before.call(this, _cmdPayload as IN)) ?? _cmdPayload;

    if (ajaxOptions?.queryParams) {
      fullUrl += `?${param(ajaxOptions.queryParams)}`;
    }
    let response: OUT = (await _adapter.ajax(fullUrl, 'PATCH', {
      ...(ajaxOptions ?? {}),
      data
    })) as OUT;

    if (isDocWithData(response)) {
      response = normalizeFn(_modelName, response) as OUT;
    }

    if (after) {
      return after.call(this, _cmdPayload as IN, response) as OUT;
    }
    return response;
  };
}
